import React, {useEffect, useState } from 'react'
import { Routes, Route, } from 'react-router-dom'
import {
    home,
    forgotpassword,
    resetpassword,
    ordermanagement,
    productcatalog,
    customermanagement,
    promotionsmanagement,
    shippingmanagement,
    paymentsmanagement,
    contactus,
    privacypolicy,
    termsandconditions,
    vendorlisting,
    categoricallisting,
    vendorpromotion,
    consumerpromocodemanagement,
    commissionmanagement,
    querymanagement,
    sizemanagement,
    colormanagement,
    typemanagement,
    materialmanagement,
    editprofile,
    changepassword,
    coloraddedit,
    materialaddedit,
    typeaddedit,
    sizeaddedit,
    subcategorymanagement,
    subcategoryaddedit,
    categorymanagement,
    categoryaddedit,
    designerManagement,
    designerview,
    viewproductdetails,
    viewvariantdetails,
    buyermanagement,
    viewbuyerdetails,
    viewquerydetails,
    faqmanagement,
    notfound,
    shippinginformation,
    returnandexchange,
    legalandpolicy,
    configurationmanagement,
    bannermanagement
} from './routingConsts'
import Login from '../pages/Login'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import SignUpLayout from '../components/Layout/SignUpLayout'
import Dashboard from '../pages/Dashboard/Dashboard'
import OrderManagement from '../pages/OrderManagement'
import ProductCatalog from '../pages/ProductCatalog'
import CustomerManagement from '../pages/CustomerManagement'
import ShippingManagement from '../pages/ShippingManagement'
import Contactus from '../pages/Contactus'
import DashboardLayout from '../components/Layout/Dashboard/DashboardLayout'
import PromotionsManagement from '../pages/PromotionsManagement'
import PaymentsManagement from '../pages/PaymentsManagement'
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from '../pages/TermsAndConditions/TermsAndConditions'
import VendorListing from '../pages/VendorListing'
import CategoricalListing from '../pages/CategoricalListing'
import SubCategoryManagement from '../pages/SubCategoryManagement'
import VendorPromotion from '../pages/VendorPromotion/VendorPromotion'
import ConsumerPromocodeManagement from '../pages/ConsumerPromocodeManagement'
import QueryManagement from '../pages/QueryManagement'
import SizeManagement from '../pages/SizeManagement'
import { useAdminInfo } from '../context/AdminContextDetail'
import { AxiosInterceptor } from '../utils/request'
import ProtectedRoutes from './ProtectedRoutes'
import CommissionManagement from '../pages/CommissionManagement'
import ColorManagement from '../pages/ColorManagement'
import TypeManagement from '../pages/TypeManagement'
import MaterialManagement from '../pages/MaterialManagement'
import EditProfile from '../pages/EditProfile'
import ChangePassword from '../pages/ChangePassword'
import CategoryManagement from '../pages/CategoryManagement'
import DesignerManagement from '../pages/DesignerManagement'
import DesignerView from '../pages/DesignerView'
import ViewProductDetails from '../pages/ViewProductDetails/ViewProductDetails'
import ViewVariantDetails from '../pages/ViewVariantDetails/ViewVariantDetails'
import BuyerManagement from '../pages/BuyerManagement/BuyerManagement'
import ViewBuyerDetails from '../pages/ViewBuyerDetails/ViewBuyerDetails'
import ViewQueryDetails from '../pages/ViewQueryDetails/ViewQueryDetails'
import FAQManagement from '../pages/FAQManagement/FAQManagement'
import NotFound from '../pages/NotFound'
import NoConnection from '../components/NoConnection/NoConnection'
import ShippingInformation from '../pages/ShippingInformation'
import ReturnandExchnage from '../pages/ReturnandExchnage'
import LegalandPolicy from '../pages/LegalandPolicy'
import ConfigurationManagment from '../pages/ConfigurationManagement'
import BannerManagement from '../pages/BannerManagement/BannerManagement'

const Routing = () => {
    
    const [isOnline, setIsOnline] = useState(window.navigator.onLine);
 
    useEffect(() => {
        const handleOnlineStatusChange = () => {
            setIsOnline(window.navigator.onLine);
        };

        // Add event listeners to check for online/offline status changes
        window.addEventListener('online', handleOnlineStatusChange);
        window.addEventListener('offline', handleOnlineStatusChange);

        // Clean up the event listeners when the component unmounts
        return () => {
            window.removeEventListener('online', handleOnlineStatusChange);
            window.removeEventListener('offline', handleOnlineStatusChange);
        };
    }, [isOnline]);

    const { currentUser } = useAdminInfo()

    return (
        <>
        {
            isOnline ? 
            <AxiosInterceptor>  
                <Routes>
                    {!currentUser ? (
                        <Route path={home} element={<SignUpLayout />}>
                            <Route index element={<Login />} />
                            <Route
                                path={forgotpassword}
                                element={<ForgotPassword />}
                            />
                            <Route
                               path={`${resetpassword}/:token`}
                                element={<ResetPassword />}
                            />
                         <Route path={notfound} element={<NotFound/>} />
                        </Route>
                    ) : (
                        <>
                            <Route path={home} element={<DashboardLayout />}>
                              <Route index element={<Dashboard />} />

                                <Route
                                    path={categorymanagement}
                                    element={<CategoryManagement />}
                                />
                                <Route
                                    path={buyermanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <BuyerManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={viewbuyerdetails}
                                    element={
                                        <ProtectedRoutes>
                                            <ViewBuyerDetails />
                                        </ProtectedRoutes>
                                    }
                                />
                                    <Route
                                    path={`${viewbuyerdetails}/:userId`}
                                    element={
                                        <ProtectedRoutes>
                                            <ViewBuyerDetails />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={ordermanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <OrderManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                 <Route
                                    path={configurationmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <ConfigurationManagment />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route path={bannermanagement}
                                  element={
                                    <ProtectedRoutes>
                                        <BannerManagement />
                                    </ProtectedRoutes>
                                  }
                                />

                                <Route
                                    path={editprofile}
                                    element={
                                        <ProtectedRoutes>
                                            <EditProfile />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={changepassword}
                                    element={
                                        <ProtectedRoutes>
                                            <ChangePassword />
                                        </ProtectedRoutes>
                                    }
                                />

                                <Route
                                    path={productcatalog}
                                    element={
                                        <ProtectedRoutes>
                                            <ProductCatalog />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={viewproductdetails}
                                    element={
                                        <ProtectedRoutes>
                                            <ViewProductDetails />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={`${productcatalog}/:catalogId`}
                                    element={
                                        <ProtectedRoutes>
                                            <ViewProductDetails />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={`${productcatalog}/:catalogId/:productId`}
                                    element={
                                        <ProtectedRoutes>
                                            <ViewVariantDetails />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={sizemanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <SizeManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={colormanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <ColorManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={typemanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <TypeManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={materialmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <MaterialManagement />
                                        </ProtectedRoutes>
                                    }
                                />

                                <Route
                                    path={designerManagement}
                                    element={
                                        <ProtectedRoutes>
                                            <DesignerManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={designerview}
                                    element={
                                        <ProtectedRoutes>
                                            <DesignerView />
                                        </ProtectedRoutes>
                                    }
                                />

                                <Route
                                    path={`${designerview}/:sellerId`}
                                    element={
                                        <ProtectedRoutes>
                                            <DesignerView />
                                        </ProtectedRoutes>
                                    }
                                />

                                <Route
                                    path={customermanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <CustomerManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={promotionsmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <PromotionsManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={shippingmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <ShippingManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={paymentsmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <PaymentsManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={contactus}
                                    element={
                                        <ProtectedRoutes>
                                            <Contactus />
                                        </ProtectedRoutes>
                                    }
                                />

                                <Route
                                    path={faqmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <FAQManagement />
                                        </ProtectedRoutes>
                                    }
                                />

                                <Route
                                    path={privacypolicy}
                                    element={
                                        <ProtectedRoutes>
                                            <PrivacyPolicy />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={termsandconditions}
                                    element={
                                        <ProtectedRoutes>
                                            <TermsAndConditions />
                                        </ProtectedRoutes>
                                    }
                                />
                                 <Route
                                    path={shippinginformation}
                                    element={
                                        <ProtectedRoutes>
                                            <ShippingInformation />
                                        </ProtectedRoutes>
                                    }
                                />
                                   <Route
                                    path={returnandexchange}
                                    element={
                                        <ProtectedRoutes>
                                            <ReturnandExchnage />
                                        </ProtectedRoutes>
                                    }
                                />
                                         <Route
                                    path={legalandpolicy}
                                    element={
                                        <ProtectedRoutes>
                                            <LegalandPolicy />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={vendorlisting}
                                    element={
                                        <ProtectedRoutes>
                                            <VendorListing />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={categoricallisting}
                                    element={
                                        <ProtectedRoutes>
                                            <CategoricalListing />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={subcategorymanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <SubCategoryManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={vendorpromotion}
                                    element={
                                        <ProtectedRoutes>
                                            <VendorPromotion />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={consumerpromocodemanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <ConsumerPromocodeManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={commissionmanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <CommissionManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={querymanagement}
                                    element={
                                        <ProtectedRoutes>
                                            <QueryManagement />
                                        </ProtectedRoutes>
                                    }
                                />
                                <Route
                                    path={viewquerydetails}
                                    element={
                                        <ProtectedRoutes>
                                            <ViewQueryDetails />
                                        </ProtectedRoutes>
                                    }
                                />
                                      <Route path={notfound} element={<NotFound/>} />
                            </Route>
                        </>
                    )}
                </Routes>
            </AxiosInterceptor>
            :
            (
               <NoConnection />
            )
        }
        </>
    )
}

export default Routing
